import { useTLang } from 'intl/intl';

export function useSupportWebChatButtonLang(props: { showShortText: boolean }) {
  const { showShortText } = props;

  const btnText = useTLang({
    id: showShortText
      ? 'orderDetailDialogCustomerBox.supportWebChatShortText'
      : 'orderDetailDialogCustomerBox.supportWebChatLongText',
  });

  return {
    btnText,
  };
}
